import React from 'react';
import { motion } from 'framer-motion';
import { ParticleField } from './ParticleField';
import { GlowButton } from './GlowButton';
interface HeroProps {
  onStart: () => void;
}
export function Hero({
  onStart
}: HeroProps) {
  return <motion.div className="relative w-full min-h-screen flex flex-col items-center justify-center px-6 py-12 overflow-hidden" initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} transition={{
    duration: 0.6
  }} data-id="element-8">
      {/* Background Image with Blur */}
      <div className="absolute inset-0 z-0" style={{
      backgroundImage: `url('https://cdn.magicpatterns.com/uploads/5HpFctqm7LezABNzmmsjiM/hacer_la_magen_mas_pro.._202605281127.jpg')`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      filter: 'grayscale(100%) contrast(1.1) blur(40px)',
      opacity: 0.25,
      maskImage: 'linear-gradient(to bottom, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0) 100%)',
      WebkitMaskImage: 'linear-gradient(to bottom, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0) 100%)'
    }} data-id="element-9" />

      {/* Radial Gradient Overlay */}
      <div className="absolute inset-0 z-0" style={{
      background: 'radial-gradient(ellipse at center, rgba(255,45,111,0.08) 0%, rgba(0,0,0,0) 70%)'
    }} data-id="element-10" />

      <ParticleField data-id="element-11" />

      {/* Content */}
      <div className="relative z-10 max-w-md w-full flex flex-col items-center text-center space-y-8" data-id="element-12">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2,
        duration: 0.6
      }} className="text-xs tracking-[0.3em] uppercase text-white/40 font-medium" data-id="element-13">
          EL JUEGO DEL DESEO
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.4,
        duration: 0.6
      }} className="text-4xl md:text-5xl font-display font-bold leading-tight tracking-tight" data-id="element-14">
          DESCUBRÍ QUÉ EXPERIENCIA ENCAJA CON USTEDES
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.6,
        duration: 0.6
      }} className="text-base text-white/60 leading-relaxed max-w-sm" data-id="element-15">
          Un juego interactivo diseñado para romper la rutina y despertar la
          conexión.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.8,
        duration: 0.6
      }} className="w-full pt-4" data-id="element-16">
          <GlowButton onClick={onStart} fullWidth data-id="element-17">
            EMPEZAR
          </GlowButton>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 1,
        duration: 0.6
      }} className="text-xs text-white/40 tracking-wide" data-id="element-18">
          60 segundos · 100% privado
        </motion.div>
      </div>
    </motion.div>;
}